import { render } from "./PublicationFileUpload.vue?vue&type=template&id=7ec8667e"
import script from "./PublicationFileUpload.vue?vue&type=script&lang=ts"
export * from "./PublicationFileUpload.vue?vue&type=script&lang=ts"
script.render = render

export default script